/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { HomepageCarousel } from "../blocks/Hero/HomepageCarousel";
import { Meta } from "../blocks/Meta/Meta";
import { config } from "../config/config";
import { useLanguage } from "../i18n/useLanguage";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";

export const DealerHomePage: FunctionComponent = () => {
  const { LandingPageContent } = config;
  const dealerInfo = useNullableDealerAccountInfo();
  const [language] = useLanguage();

  return (
    <>
      <Meta
        cmsTitle={
          dealerInfo?.dealerRetailSiteCustomTitle[language]?.trim() ?? null
        }
        title={"dealerHomePage"}
      />
      <HomepageCarousel />
      <LandingPageContent />
    </>
  );
};
